<template>
<div class="row" style="height: 100%;">
  <div class="col-xs-12">
    <router-link style="display: inline-flex; align-items: center; font-size: 20pt;" :to="{name: 'ClassActivities', query: {'course': courseId, 'week': weekId}}" v-slot="{navigate}">
      <a class="btn btn-default" style="border: 0; text-decoration: initial; cursor: pointer;" @click="navigate">
        <i class="material-icons" style="font-size: 30pt;">arrow_back</i>
      </a>
    </router-link>
  </div>
  <div class="col-xs-offset-1 col-xs-10" style="padding:10px; height: 100%;">
    <VideoActivity ref="a" v-if="isVideo" :courseId="courseId" :weekId="weekId" :id="id" :activity.sync="activity"/>
    <AssignActivity ref="a" v-else :courseId="courseId" :weekId="weekId" :id="id" :activity.sync="activity"/>
  </div>
</div>
</template>
<style type="text/css" scoped>
  #discussion_list p{
    margin-bottom: 0;
  }
  .discussion_cell, .reply_cell{
    margin-bottom: 16px;
  }
  .discussion_cell:last-child, .reply_cell:last-child{
    margin-bottom: 0;
  }
  .reply_cell:first-child{
    margin-top: 16px;
  }
  .reply_to{
    background-color: #EEE;
    margin-right: 10px;
  }
  .discussion_cell .comment_datetime{
    margin: 0 10px;
  }
</style>
<script>
import VideoActivity from '@/components/Video/VideoActivity'
import AssignActivity from '@/views/Class/AssignActivity'

// import $ from 'jquery'
export default {
  components: {
    VideoActivity,
    AssignActivity
  },
  data () {
    return {
      // name: '',
      // description: '',
      activity: {}
    }
  },
  computed: {
    courseId: function () {
      return parseInt(this.$route.query.course)
    },
    weekId: function () {
      return parseInt(this.$route.query.week)
    },
    id: function () {
      return parseInt(this.$route.query.activity)
    },

    type: function () {
      console.log(this.activity.type)
      return this.activity.type
    },
    isVideo: function () {
      return this.activity.type === 'Video'
    },
    role: function () {
      return this.$parent.role
    }
  },
  mounted: function () {
    this.$store.dispatch('request', {
      route: `courses/${this.courseId}/weeks/${this.weekId}/activities/${this.id}`
    }).then(activity => {
      console.log(activity)
      // this.name = activity.name
      // this.description = activity.description
      this.activity = activity
      // this.$refs.a.$forceUpdate()
    })
    if (this.role === 'student') {
      this.$store.dispatch('request', {
        method: 'post',
        route: `courses/${this.courseId}/weeks/${this.weekId}/activities/${this.id}/view`
      })
    }
  }
}
</script>
